var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.50078V0.300781H0V14.7008H16V3.50078H8ZM6.4 13.1008H1.6V11.5008H6.4V13.1008ZM6.4 9.90078H1.6V8.30078H6.4V9.90078ZM6.4 6.70078H1.6V5.10078H6.4V6.70078ZM6.4 3.50078H1.6V1.90078H6.4V3.50078ZM14.4 13.1008H8V5.10078H14.4V13.1008ZM12.8 6.70078H9.6V8.30078H12.8V6.70078ZM12.8 9.90078H9.6V11.5008H12.8V9.90078Z",
    fill: "#183059"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgIcon);
export default __webpack_public_path__ + "static/media/org_icon.0f258e4f9f03c4c503cdde21f5807ce0.svg";
export { ForwardRef as ReactComponent };